export class TopBar {
  private scene;

  constructor(scene, screenWidth) {
    this.scene = scene;
    const topbar = this.scene.add.sprite(screenWidth / 2, 82, 'topbar').setDepth(1);
    topbar.setDisplaySize(screenWidth, 164);
  }
}
